<template>
  <div id="showCart">
    <div class="container" v-if="products != undefined">
      <table>
        <tr>
          <th>商品</th>
          <th>品項</th>
          <th>總計</th>
        </tr>
        <tr :key="index" v-for="(item, index) in products">
          <td>
            <div class="image">
              <img v-lazy="item.display_img_small" :alt="item.group_name" />
            </div>
            <div class="info">
              <div class="title">
                {{ item.form_name }}
                <div class="items" v-if="item.sub && item.sub.length != 0">
                  <div
                    class="item"
                    :key="num"
                    v-for="(e, num) in item.sub"
                    :class="{ gift: e.sub_type != 'SNOR' }"
                  >
                    <template v-if="e.sub_type != 'SNOR'">贈-</template
                    >{{ e.form_name }} x{{ e.num }}
                  </div>
                </div>
              </div>
              <div class="desc">
                <i
                  :key="index"
                  v-for="(consigItem, index) in consignmentRemarks(item)"
                  >{{ consigItem.remark }}</i
                >
                <i> {{ item.type }}</i>
              </div>
            </div>
          </td>
          <td>
            {{ item.num }} x
            {{ parseFloat(item.price.replace(/[^0-9.]/g, "")) | priceFilter }}
          </td>
          <td>
            {{ parseFloat(item.total.replace(/[^0-9.]/g, "")) | priceFilter }}
          </td>
        </tr>
        <tr v-if="list == undefined">
          <td colspan="3" class="totalInfo">
            <span
              class="delivery"
              v-if="products[products.length - 1].price != 0"
            >
              運費：{{
                parseFloat(
                  products[products.length - 1].price.replace(/[^0-9.]/g, "")
                ) | priceFilter
              }}
              <br />

              <span class="tips">
                <i
                  >滿{{
                    parseFloat(
                      shopCart.shipment_upper_money.replace(/[^0-9.]/g, "")
                    ) | priceFilter
                  }}元免運費,還差{{
                    parseFloat(shopCart.shipment.replace(/[^0-9.]/g, ""))
                      | priceFilter
                  }}
                </i>
              </span>
            </span>
            <span class="delivery" v-else>
              <span class="tips"><i>已免運費</i></span>
            </span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ShowCart",
  props: ["list"],
  data() {
    return {};
  },
  computed: {
    ...mapState("checkout", ["shopCart", "consignmentRemark"]),
    // 购物车商品（暂时为过滤的方式）
    products() {
      let arr = this.list || this.shopCart.item;
      return arr.filter((product) => product.type != "SYS");
    },
  },
  methods: {
    consignmentRemarks(item) {
      return this.consignmentRemark
        .filter((c) => c.itemid === item.item_id)
        .map((product) => ({
          ...product,
          sub:
            product.sub && product.sub.length
              ? product.sub.filter((e) => e.num !== 0) // 过滤 sub 数组
              : [], // 如果没有 sub 数组，使用空数组
        }));
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
#showCart {
  padding: 0.5em 5em;
  .mobile({padding: 0.2em});
  .container {
    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      border: 1px solid #ececec;
    }
    table {
      width: 100%;
      text-align: center;
      border-collapse: collapse;
    }

    .totalInfo {
      padding-right: 6em;
      width: 152% !important;
      .mobile({
          padding-right:0.8em !important ;});
      .delivery {
        width: 100%;
        text-align: right;
        color: @primary-color;
        .mobile({
          padding-right:0em !important ;
          font-size: 0.8em;
        });
      }
      .tips {
        color: red;
        font-size: 0.5em;
      }
    }
    th {
      min-width: 5em;
      .mobile({
        border-radius: 0;
        padding: 0.1em 0.5em;
        font-size: 0.8em;
      });
    }
    td {
      min-height: 6em;
      padding: 1em 0;
      border-bottom: 1px solid #ececec;
    }
    td:nth-child(1) {
      .flex-mixin(row,flex-start,center);
      text-align: left;
      overflow: hidden;
      vertical-align: middle;
      .mobile({
        padding-left: 0.2em;
        font-size: 0.8em
      });
      .image {
        width: 4.5em;
        height: 4.5em;
        .mobile({
          width: 5.5em;
          height: 4em
        });
      }
      .info {
        position: relative;
        top: -0.5em;
        left: 1em;
        font-size: 0.8em;
        color: @primary-color;
        .items {
          .flex-mixin(row,start,center);
          flex-wrap: wrap;
          .item {
            border: 1px solid #f0f2f5;
            margin: 0.2em;
            margin-left: 0;
            padding: 0.1em 0.5em;
            background: #f0f2f5;
            color: #909399;
            border-radius: 5px;
            position: relative;
            overflow: hidden;
            font-size: 0.8em;
          }
          .gift {
            background-color: #ff0000;
            color: #fff;
            border: 1px solid #ff0000;
          }
        }
        .mobile({
          left: 0.5em;
          font-size: 0.6em;
          padding-right:  2em;
          
        });
        .desc {
          font-family: @font-family-regular;
          .mobile({
            font-size: 0.6em;
          });
        }
        .mobile({
          font-size: 0.8em;
        });
      }
    }
    td:nth-child(2) {
      font-family: @font-family-regular;
      .mobile({
        font-size: 0.8em;
      });
    }
    td:nth-child(3) {
      color: #ff9e1b;
      .mobile({
        font-size: 0.8em;
      });
    }
  }
}
</style>
